import { StarFill } from 'react-bootstrap-icons';

import { Rate as RateANTD, RateProps } from 'antd';

import styled, { StyledProp } from '@/styled';

interface RateStyledProps {
  isFetching: boolean;
}

interface CustomRateComponentProps {
  onChange: (value: number) => void;
  userRating: number;
}

const Rate = ({
  onChange,
  className,
  userRating,
  isFetching
}: RateProps & StyledProp & RateStyledProps & CustomRateComponentProps) => {
  return (
    <RateANTD
      defaultValue={userRating}
      onChange={onChange}
      rootClassName={className}
      character={<StarFill />}
      disabled={isFetching}
      value={userRating}
    />
  );
};

export default styled(Rate)`
  margin-top: ${({ theme }) => theme.space.pxToRem(24)};

  svg {
    font-size: ${({ theme }) => theme.space.pxToRem(24)};
    color: ${({ theme }) => theme.palette.gray[8]};
  }

  *[aria-checked='true'] {
    svg {
      color: ${({ theme }) => theme.colorPrimary};
    }
  }
`;
